import { useDisclosure } from '@chakra-ui/react';

import DownloadDiagramModal from '../../DownloadDiagramModal';
import TrackedMenuItem from '../TrackedMenuItem';

const DownloadDiagramMenuItem: React.FC = () => {
  const disclosure = useDisclosure();

  return (
    <>
      <TrackedMenuItem value="download" onClick={disclosure.onOpen}>
        Download
      </TrackedMenuItem>
      <DownloadDiagramModal {...disclosure} />
    </>
  );
};

export default DownloadDiagramMenuItem;
